import * as API from '../api'
export const FETCH_ATCCLASSIFICATION = 'FETCH_ATCCLASSIFICATION'
export const FETCHING_ATCCLASSIFICATION = 'FETCHING_ATCCLASSIFICATION'
export const FETCH_ATCCLASSIFICATION_ERROR = 'FETCH_ATCCLASSIFICATION_ERROR'
export const FETCH_ATCCLASSIFICATIONS = 'FETCH_ATCCLASSIFICATIONS'
export const FETCHING_ATCCLASSIFICATIONS = 'FETCHING_ATCCLASSIFICATIONS'
export const FETCH_ATCCLASSIFICATIONS_ERROR = 'FETCH_ATCCLASSIFICATIONS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_ATCCLASSIFICATION = 'CHANGE_ATCCLASSIFICATION'
export const DELETE_ATCCLASSIFICATION = 'DELETE_ATCCLASSIFICATION'
export const ADD_ATCCLASSIFICATION = 'ADD_ATCCLASSIFICATION'
export const EDIT_ATCCLASSIFICATION = 'EDIT_ATCCLASSIFICATION'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_ATCCLASSIFICATION = 'NEW_FORM_ATCCLASSIFICATION'
export const ATCCLASSIFICATION_FORM_ERROR = 'ATCCLASSIFICATION_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeAtcClassification = atcClassification => {
  return dispatch => {
    dispatch({ type: CHANGE_ATCCLASSIFICATION, atcClassification })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleAtcClassificationError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: ATCCLASSIFICATION_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormAtcClassification = atcClassification => {
  return dispatch => {
    dispatch({ type: NEW_FORM_ATCCLASSIFICATION })
  }
}

export const setAtcClassificationFormTouched = atcClassification => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreAtcClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATIONS })
    return API.atcClassifications
      .restoreAtcClassification(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_ATCCLASSIFICATION, atcClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleAtcClassificationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchAtcClassifications = options => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATIONS })
    return API.atcClassifications
      .getAtcClassifications(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS,
          atcClassifications: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteAtcClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATIONS })
    return API.atcClassifications
      .deleteAtcClassification(id)
      .then(({ data: atcClassification }) => {
        dispatch({ type: DELETE_ATCCLASSIFICATION, atcClassification })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addAtcClassification = atcClassification => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATIONS })
    dispatch({ type: FETCHING_ATCCLASSIFICATION })
    return API.atcClassifications
      .addAtcClassification(atcClassification)
      .then(({ data }) => {
        dispatch({ type: ADD_ATCCLASSIFICATION, atcClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleAtcClassificationError(response, dispatch)
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editAtcClassification = atcClassification => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATIONS })
    dispatch({ type: FETCHING_ATCCLASSIFICATION })
    return API.atcClassifications
      .editAtcClassification(atcClassification)
      .then(({ data }) => {
        dispatch({ type: EDIT_ATCCLASSIFICATION, atcClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_ATCCLASSIFICATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleAtcClassificationError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchAtcClassification = id => {
  return dispatch => {
    dispatch({ type: FETCHING_ATCCLASSIFICATION, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.atcClassifications
      .getAtcClassification(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_ATCCLASSIFICATION, atcClassification: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_ATCCLASSIFICATION_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/atcClassifications.js